import { TReportExportType } from '../../models'

export const exportBlobTypeMap: Partial<Record<TReportExportType, string>> = {
  csv: 'text/csv;charset=utf-8',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
}
